/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Creations_Viewreleases1Inputs */

const id_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Rilis`)
};

const ms_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Keluaran`)
};

const da_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Udgivelser`)
};

const de_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungen ansehen`)
};

const en_us2_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Releases`)
};

const es_es2_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver lanzamientos`)
};

const es_mx2_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver lanzamientos`)
};

const fil_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan ang mga Release`)
};

const fr_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les sorties`)
};

const it_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi uscite`)
};

const hu_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelenések megtekintése`)
};

const nl_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releases bekijken`)
};

const no_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis utgivelser`)
};

const pl_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz wydania`)
};

const pt_br2_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver lançamentos`)
};

const pt_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver lançamentos`)
};

const ro_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi lansări`)
};

const fi_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä julkaisut`)
};

const sv_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa släpp`)
};

const vi_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem bản phát hành`)
};

const tr_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkışları Görüntüle`)
};

const cs_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit vydání`)
};

const bg_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вижте издания`)
};

const ru_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть релизы`)
};

const uk_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути релізи`)
};

const ar_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الإصدارات`)
};

const hi_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिलीज़ देखें`)
};

const th_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูการวางจำหน่าย`)
};

const ja_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリースを見る`)
};

const zh_cn2_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看发布`)
};

const zh_hant1_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢視發布`)
};

const ko_stats_creations_viewreleases1 = /** @type {(inputs: Stats_Creations_Viewreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 보기`)
};

/**
* | output |
* | --- |
* | "View Releases" |
*
* @param {Stats_Creations_Viewreleases1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_creations_viewreleases1 = /** @type {((inputs?: Stats_Creations_Viewreleases1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Creations_Viewreleases1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_creations_viewreleases1(inputs)
	if (locale === "ms") return ms_stats_creations_viewreleases1(inputs)
	if (locale === "da") return da_stats_creations_viewreleases1(inputs)
	if (locale === "de") return de_stats_creations_viewreleases1(inputs)
	if (locale === "en-US") return en_us2_stats_creations_viewreleases1(inputs)
	if (locale === "es-ES") return es_es2_stats_creations_viewreleases1(inputs)
	if (locale === "es-MX") return es_mx2_stats_creations_viewreleases1(inputs)
	if (locale === "fil") return fil_stats_creations_viewreleases1(inputs)
	if (locale === "fr") return fr_stats_creations_viewreleases1(inputs)
	if (locale === "it") return it_stats_creations_viewreleases1(inputs)
	if (locale === "hu") return hu_stats_creations_viewreleases1(inputs)
	if (locale === "nl") return nl_stats_creations_viewreleases1(inputs)
	if (locale === "no") return no_stats_creations_viewreleases1(inputs)
	if (locale === "pl") return pl_stats_creations_viewreleases1(inputs)
	if (locale === "pt-BR") return pt_br2_stats_creations_viewreleases1(inputs)
	if (locale === "pt") return pt_stats_creations_viewreleases1(inputs)
	if (locale === "ro") return ro_stats_creations_viewreleases1(inputs)
	if (locale === "fi") return fi_stats_creations_viewreleases1(inputs)
	if (locale === "sv") return sv_stats_creations_viewreleases1(inputs)
	if (locale === "vi") return vi_stats_creations_viewreleases1(inputs)
	if (locale === "tr") return tr_stats_creations_viewreleases1(inputs)
	if (locale === "cs") return cs_stats_creations_viewreleases1(inputs)
	if (locale === "bg") return bg_stats_creations_viewreleases1(inputs)
	if (locale === "ru") return ru_stats_creations_viewreleases1(inputs)
	if (locale === "uk") return uk_stats_creations_viewreleases1(inputs)
	if (locale === "ar") return ar_stats_creations_viewreleases1(inputs)
	if (locale === "hi") return hi_stats_creations_viewreleases1(inputs)
	if (locale === "th") return th_stats_creations_viewreleases1(inputs)
	if (locale === "ja") return ja_stats_creations_viewreleases1(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_creations_viewreleases1(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_creations_viewreleases1(inputs)
	return ko_stats_creations_viewreleases1(inputs)
});
export { stats_creations_viewreleases1 as "stats.creations.viewReleases" }